<div class="products-modal" *transloco="let t; prefix: 'assetOverview.products'">
  <div class="products-modal__header">
    <div>
      @if (selectedCard) {
        <h3 class="products-modal__title">{{ selectedCard.title }}</h3>
        <p class="products-modal__subtitle">{{ selectedCard.description }}</p>
      } @else {
        <h3 class="products-modal__title">{{ t('title') }}</h3>
        <p class="products-modal__subtitle">{{ t('subtitle') }}</p>
      }
    </div>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="close()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  @if (selectedCard && selectedDetails) {
    @if (selectedDetails.keyFeatures.length) {
      <div class="details-section">
        <h4 class="details-section__title">{{ t('keyFeatures') }}</h4>
        <div class="details-section__features">
          @for (feature of selectedDetails.keyFeatures; track feature.title) {
            <div class="feature-row">
              <span class="feature-row__icon">
                <i class="ph ph-check-fat"></i>
              </span>
              <div>
                <p class="feature-row__title">{{ feature.title }}</p>
                <p class="feature-row__description">{{ feature.description }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (selectedDetails.installation; as installation) {
      <div class="details-section">
        <h4 class="details-section__title">{{ t('installationInformation') }}</h4>
        <div class="details-section__installation">
          <div>
            <p class="installation-label">{{ t('estimatedTime') }}</p>
            <p class="installation-value">{{ installation.estimatedTime }}</p>
          </div>
          <div>
            <p class="installation-label">{{ t('location') }}</p>
            <p class="installation-value">{{ installation.location }}</p>
          </div>
          <div>
            <p class="installation-label">{{ t('requirements') }}</p>
            <p class="installation-value">{{ installation.requirements }}</p>
          </div>
          <div>
            <p class="installation-label">{{ t('warranty') }}</p>
            <p class="installation-value">{{ installation.warranty }}</p>
          </div>
        </div>
      </div>
    }

    <div class="products-modal__actions">
      <button type="button" class="btn-close-modal" (click)="backToProducts()">
        <span>{{ t('back') }}</span>
      </button>
      <button type="button" class="btn-request-upgrades" [disabled]="isSendingRequest" (click)="requestSelectedProductAsync()">
        <span>{{ isSendingRequest ? t('sending') : t('requestFittingUpgrade') }}</span>
      </button>
    </div>
  } @else {
    @if (isLoading) {
      <div class="products-modal__state products-modal__state--spinner">
        <div class="spinner-border"></div>
      </div>
    } @else if (hasError) {
      <div class="products-modal__state">
        <app-error-state></app-error-state>
      </div>
    } @else {
      <div class="products-modal__grid">
        @for (card of productCards; track card.key) {
          <div class="product-card">
            <div class="product-card__header">
              <h4 class="product-card__title">{{ card.title }}</h4>
              @if (card.isInstalled) {
                <span class="status-chip status-chip--installed">
                  <i class="ph-fill ph-check-circle"></i>
                  {{ t('installed') }}
                </span>
              } @else {
                <span class="status-chip status-chip--not-installed">
                  <i class="ph-fill ph-warning-circle"></i>
                  {{ t('notInstalled') }}
                </span>
              }
            </div>

            <p class="product-card__quantity">{{ t('quantity', { count: card.quantity }) }}</p>
            <p class="product-card__description" title="{{ card.description }}">{{ card.description }}</p>

            <button
              type="button"
              class="product-card__action"
              [disabled]="!card.actionEnabled"
              (click)="openProductDetails(card)">
              {{ card.actionLabel }}
            </button>
          </div>
        }
      </div>
    }

    <div class="products-modal__actions">
      <button type="button" class="btn-close-modal" (click)="close()">
        <span>{{ 'common.close' | transloco }}</span>
      </button>
      <button type="button" class="btn-request-upgrades" [disabled]="isLoading || hasError || isSendingRequest" (click)="requestUpgradesAsync()">
        <span>{{ isSendingRequest ? t('sending') : t('requestUpgrades') }}</span>
      </button>
    </div>
  }
</div>
